module.exports = __webpack_public_path__ + "fonts/ionicons.96f1c901.woff2";